function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { TeaPerfMetricName, NAVIGATE_TIME } from "./const";
import { getAllPerformanceMetrics, getCommonParams, getDCLTime, reportTTAPActualFMP, sparkMark } from "./utils";
import { Scene } from "../types";
class PerfTrackingModule {
  resetForSPA() {
    this._hasReportedActualFMP = false;
  }
  constructor(trackingContext) {
    this._hasReportedActualFMP = false;
    this._hasReportedFBJS = false;
    this.reportFBJS = () => {
      var _this__trackingContext_sparkMonitor, _window, _performance_mark, _performance;
      if (this._hasReportedFBJS) {
        return;
      }
      this._hasReportedFBJS = true;
      const currentTime = Date.now();
      window.TTAP_APPPARSE_STARTTIME = currentTime;
      if (typeof ((_this__trackingContext_sparkMonitor = this._trackingContext.sparkMonitor) === null || _this__trackingContext_sparkMonitor === void 0 ? void 0 : _this__trackingContext_sparkMonitor.mark) === "function") {
        this._trackingContext.sparkMonitor.mark("fbjs");
      } else if (this._trackingContext.slardarHybridGlobalName && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window[this._trackingContext.slardarHybridGlobalName]) === "function") {
        sparkMark("fbjs");
      }
      (_performance = performance) === null || _performance === void 0 ? void 0 : (_performance_mark = _performance.mark) === null || _performance_mark === void 0 ? void 0 : _performance_mark.call(_performance, "pns_privacy_product_mark_fbjs");
      this._trackingContext.sendEvent({
        name: TeaPerfMetricName.FBJS,
        metrics: {
          cost_ms: currentTime - NAVIGATE_TIME
        },
        categories: _object_spread({}, getCommonParams())
      });
    };
    this.reportActualFMP = (scene = Scene.normal) => {
      var _performance_mark, _performance, _window, _this__trackingContext_slardarContainer;
      if (this._hasReportedActualFMP) {
        return;
      }
      this._hasReportedActualFMP = true;
      const normalScenes = [
        Scene.normal,
        Scene.noRecord
      ];
      const isSuccess = normalScenes.includes(scene);
      const currentTime = Date.now();
      (_performance = performance) === null || _performance === void 0 ? void 0 : (_performance_mark = _performance.mark) === null || _performance_mark === void 0 ? void 0 : _performance_mark.call(_performance, "pns_privacy_product_mark_afmp");
      if (isSuccess) {
        var _this__trackingContext_sparkMonitor, _window1, _this__trackingContext, _window2;
        if (typeof ((_this__trackingContext_sparkMonitor = this._trackingContext.sparkMonitor) === null || _this__trackingContext_sparkMonitor === void 0 ? void 0 : _this__trackingContext_sparkMonitor.mark) === "function") {
          this._trackingContext.sparkMonitor.mark("fmp");
        } else if (this._trackingContext.slardarHybridGlobalName && typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1[this._trackingContext.slardarHybridGlobalName]) === "function") {
          sparkMark("fmp");
        }
        if (typeof ((_this__trackingContext = this._trackingContext) === null || _this__trackingContext === void 0 ? void 0 : _this__trackingContext.reportTTAPActualFMP) === "function") {
          this._trackingContext.reportTTAPActualFMP();
        } else if (this._trackingContext.slardarWindowGlobalName && typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2[this._trackingContext.slardarWindowGlobalName]) === "function") {
          var _window3;
          reportTTAPActualFMP((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3[this._trackingContext.slardarWindowGlobalName], currentTime - NAVIGATE_TIME);
        }
      }
      if (this._trackingContext.slardarHybridGlobalName && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window[this._trackingContext.slardarHybridGlobalName]) === "function") {
        var _window_this__trackingContext_slardarHybridGlobalName, _window4;
        (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window_this__trackingContext_slardarHybridGlobalName = _window4[this._trackingContext.slardarHybridGlobalName]) === null || _window_this__trackingContext_slardarHybridGlobalName === void 0 ? void 0 : _window_this__trackingContext_slardarHybridGlobalName.call(_window4, "sendCustomPerfMetric", {
          name: "actual_fmp",
          value: currentTime - NAVIGATE_TIME
        });
      }
      this._trackingContext.sendEvent({
        name: TeaPerfMetricName.AFMP,
        metrics: _object_spread_props(_object_spread({
          costMs: currentTime - NAVIGATE_TIME
        }, getAllPerformanceMetrics()), {
          pns_privacy_product_mark_dcl: getDCLTime()
        }),
        categories: _object_spread({
          isSuccess: isSuccess ? "1" : "0",
          scene
        }, getCommonParams())
      });
      this._trackingContext.teaReport({
        name: TeaPerfMetricName.AFMP,
        metrics: _object_spread_props(_object_spread({
          costMs: currentTime - NAVIGATE_TIME
        }, getAllPerformanceMetrics()), {
          pns_privacy_product_mark_dcl: getDCLTime()
        }),
        categories: {
          isSuccess: isSuccess ? "1" : "0",
          scene
        }
      });
      if (typeof ((_this__trackingContext_slardarContainer = this._trackingContext.slardarContainer) === null || _this__trackingContext_slardarContainer === void 0 ? void 0 : _this__trackingContext_slardarContainer.reportActualFMP) === "function") {
        this._trackingContext.slardarContainer.reportActualFMP();
      }
    };
    this._trackingContext = trackingContext;
  }
}
export {
  PerfTrackingModule
};
